import(/* webpackMode: "eager", webpackExports: ["ProductProvider"] */ "/vercel/path0/apps/varsity/src/app/[locale]/(static)/product/[product]/components/ProductContext.tsx");
